// Gatsby requirements
import React from "react"
import { Link } from 'gatsby';

const LinkLogic = ({ data, insertClass }) => {

    return (
        <>
        {data &&
            <>
            {data?.url?.linktype === "story" && data?.text && data.url.cached_url &&
                <Link
                    to={`/${data?.url.cached_url?.endsWith("/") === true ? data?.url.cached_url : data?.url.cached_url + '/'}`}
                    className={`${data.component === "Button" ? 'button' : ''} ${data.style} ${insertClass}`}
                    target={data?.openInNewWindow === true ? '_blank' : ''}
                    rel={`${data?.nofollow === true ? 'nofollow' : ''} ${data?.openInNewWindow === true ? 'noopener noreferrer' : ''}`}
                    style={{
                        marginRight: data?.marginRight ? '1.5em' : null,
                        marginBottom: data?.marginBottom ? '1em' : null,
                    }}
                >
                    {data.text}
                </Link>
            }

            {data?.url?.linktype === "url" && data?.text && data.url.cached_url &&
                <a
                    href={data.url.cached_url}
                    className={`${data.component === "Button" ? 'button' : ''} ${data.style} ${insertClass}`}
                    target={data?.openInNewWindow === true ? '_blank' : ''}
                    rel={`${data?.nofollow === true ? 'nofollow' : ''} ${data?.openInNewWindow === true ? 'noopener noreferrer' : ''}`}
                    style={{
                        marginRight: data?.marginRight ? '1.5em' : null,
                        marginBottom: data?.marginBottom ? '1em' : null,
                    }}
                >
                    {data.text}
                </a>
            }
            </>
        }
        </>
    )
}

export default LinkLogic